import React from 'react';

const CareGuide = () => {
  return (
    <div className="pt-20 min-h-screen bg-linen-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="font-display text-4xl font-semibold text-walnut-800 mb-8">
          Caring for Wood Bowls &amp; Utensils
        </h1>
        <div className="prose max-w-none">
          <p className="text-walnut-600 mb-10">
            All wood bowls and utensils need maintenance to maintain their beauty and usefulness.
          </p>

          <section id="bowls" className="mb-12 scroll-mt-24">
            <h2 className="font-display text-2xl font-semibold text-walnut-800 mb-4">
              Caring for Bowls
            </h2>
            <p className="text-walnut-600 mb-4">
              You probably already know this, but we want to emphasize that you should never
              wash your wood bowl in a dishwasher or leave it soaking in water. You can wash it
              in hot or warm water and mild dish soap, followed by a thorough rinse. Towel dry
              and let it dry overnight before putting it away.
            </p>
            <p className="text-walnut-600 mb-4">
              When you first start using your bowl, you will probably need to treat it with
              wood butter after each cleaning. Dryness or a raised grain will indicate it needs
              nourishing.
            </p>
            <p className="text-walnut-600 mb-4">
              Typically, you will treat it after every cleaning for the first 5 or 6 uses. Then
              you will treat it after every 4 or 5 cleanings. We have used our bowls for many
              years and they are well seasoned — we only need to treat them with wood butter
              once or twice a year now.
            </p>
            <p className="text-walnut-600 mb-4">
              Every few years we recondition our bowls and utensils by lightly sanding them and
              then treating with wood butter. They have developed a wonderful patina that adds
              to their beauty.
            </p>
            <p className="text-walnut-600">
              You are welcome to contact us if you would like us to recondition your bowl and
              provide you with additional wood butter. There may be a small fee for this
              depending on what needs to be done. You can also call us if you have any specific
              questions.
            </p>
          </section>

          <section id="utensils" className="mb-4 scroll-mt-24">
            <h2 className="font-display text-2xl font-semibold text-walnut-800 mb-4">
              Caring for Spoons, Spatulas &amp; Ladles
            </h2>
            <p className="text-walnut-600 mb-4">
              The care for these utensils is nearly the same as for bowls. The difference is
              that you will probably need to lightly sand your utensils for the first 5 or 6
              times you wash them. This is due to the water raising the grain when you clean
              them. Use a damp paper towel to remove any dust after sanding and then treat with
              wood butter. Once your utensils are well seasoned, you will only need to sand or
              use wood butter every year or two.
            </p>
            <p className="text-walnut-600">
              If you ever drop your utensil and it gets chipped, or you just want it
              refurbished, you are welcome to contact us for a repair and touchup. We never
              charge a fee for this service.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CareGuide;
